var React = require('react');

function MoonInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#221b16;}")),React.createElement("g",{"transform":"translate(-24.646 -8.001)","key":1},React.createElement("g",{"transform":"translate(19.646 4.001)"},React.createElement("path",{"className":"a","d":"M32,12.034a.556.556,0,0,0-.618-.172A5.864,5.864,0,0,1,29.4,12.2,6.1,6.1,0,0,1,25.97,1.058.554.554,0,0,0,25.738.05,5.381,5.381,0,0,0,24.961,0a8.315,8.315,0,1,0,7.08,12.675A.558.558,0,0,0,32,12.034Z","transform":"translate(-11.646 4)"})))]);
}

MoonInline.defaultProps = {"width":"15.477","height":"16.631","viewBox":"0 0 15.477 16.631"};

module.exports = MoonInline;

MoonInline.default = MoonInline;
